<template>
  <div class="tag-container" :class="{ active: isActive, delete: canDelete }" @click="onSelect">
    <div class="tag-inner">
      <slot></slot>
    </div>
    <a-icon type="minus-circle" theme="filled" class="close-icon" @click.stop="onDelete" />
  </div>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    onSelect: {
      type: Function,
      default: () => {}
    },
    canDelete: {
      type: Boolean,
      default: true
    },
    onDelete: {
      type: Function,
      default: () => {}
    }
  }
}
</script>

<style lang="less" scoped>
.tag-container {
  width: 100%;
  height: 36px;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
  background: #fafafa;
  position: relative;
  cursor: pointer;
  padding: 0 4px;
  transition: all 0.2s;
  user-select: none;

  &:hover {
    border: 1px solid #3377ff;
    background: #ebf2ff;
  }

  &.active {
    background: #1990ff;
    color: white;
    border: none;
  }

  .tag-inner {
    width: 100%;
    height: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-align: center;
    line-height: 34px;
  }

  .close-icon {
    cursor: pointer;
    position: absolute;
    right: -5px;
    top: -5px;
    color: #ed7878;
    display: none;
    background: white;
    border-radius: 50%;
  }

  &.delete:hover {
    .close-icon {
      display: block;
    }
  }
}
</style>